module.exports = __webpack_public_path__ + "img/payment-successful.9f985126.svg";